<template>
  <div
    class="thumbnail"
    :class="customCss"
    :style="{
      backgroundColor: backgroundColor,
      borderRadius: round,
      width: size,
      height: size,
      minWidth: size,
      totalHeight: size,
      borderWidth: borderWidth + 'px',
      borderColor: borderColor,
    }"
  >
    <template v-if="!isLoaded">
      <i
        v-if="props.defaultIcon"
        class="fi fi-rr-user default-icon"
        :style="{'font-size': props.size}"
      ></i>
      <div v-if="!props.defaultIcon" class="default-icon">
        <slot name="default-icon"></slot>
      </div>
    </template>
    <img
      v-if="sUrl"
      class="thumbnail_img"
      :src="sUrl"
      @load="onLoad"
      onerror="this.style.display='none';"
    />
  </div>
</template>

<script setup>
import {ref, watch, onMounted} from "vue";

const props = defineProps({
  customCss: {
    type: String,
    default: null,
  },
  backgroundColor: {
    type: String,
    default: "",
  },
  round: {
    type: String,
    default: "0px",
  },
  size: {
    type: String,
    default: "1rem",
  },
  defaultIcon: {
    type: Boolean,
    default: true,
  },
  borderColor: {
    type: String,
    default: "",
  },
  borderWidth: {
    type: Number,
    default: 0,
  },
  url: {
    type: String,
  },
});

let sUrl = ref(undefined);
let isLoaded = ref(false);

onMounted(() => {
  sUrl.value = props.url;
});

watch(
  () => props.url,
  (nValue) => {
    sUrl.value = nValue;

    if (!props.url) {
      isLoaded.value = false;
    }
  }
);

const onLoad = () => {
  isLoaded.value = true;
};
</script>

<style lang="scss" scoped>
.thumbnail {
  overflow: hidden;
  position: relative;
  border-style: solid;

  &_img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.default-icon {
  display: flex;
  position: absolute;
  overflow: hidden;
  z-index: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.6);
}
</style>
